import Main from './ToggleBtn/Main';
import './App.css';

function App() {
  return (
    <Main/>
  );
}

export default App;
